import { Bubble, Props } from './Bubble';
import { ChatIcon, PhoneIcon } from '@raysee/icon';
import { Coupon, Message, Plan, generatePriceText, getMaxDiscountCoupon } from '@raysee/schema';
import Image from 'next/image';
import { FC } from 'react';

interface SalesProps extends Props {
  coupons: Coupon[];
  onClick?: (url: string, message: Message) => void;
}

export const SalesBubble: FC<SalesProps> = (props) => (
  <>
    <Bubble {...props} displayStatus={!!props.message.text || props.role === 'teller'}>
      {(!!props.message.text || props.role === 'teller') && (
        <div className="rounded-2xl border bg-white px-4 py-3 drop-shadow-sm">
          <p className="whitespace-pre-wrap">{props.message.text || '営業メッセージ'}</p>
        </div>
      )}
    </Bubble>
    {props.role === 'user' && (
      <div className="mx-4 mb-4">
        <div
          className={`flex ${
            props.message.suggestNextPlans?.length === 1 ? 'justify-center' : ''
          } gap-4 overflow-x-auto pb-5`}
        >
          {props.message.suggestNextPlans?.map((plan, i) => (
            <CarouselItem
              key={i}
              plan={plan}
              message={props.message}
              coupons={props.coupons}
              onClick={props.onClick}
            />
          ))}
        </div>
      </div>
    )}
  </>
);

const CarouselItem: FC<{
  plan: Plan;
  message: Message;
  coupons: Coupon[];
  onClick: SalesProps['onClick'];
}> = ({ plan, message, coupons, onClick }) => {
  const maxDiscountCoupon = getMaxDiscountCoupon(plan, coupons);

  return (
    <button
      className="min-w-[208px] basis-[208px] rounded-xl bg-white text-left drop-shadow-xl"
      onClick={() =>
        onClick &&
        onClick(
          `${window.location.origin}/tellers/${plan.tellerId}/plans/${plan.id}?utm_campaign=${message.id}&utm_source=l&utm_medium=sales`,
          message,
        )
      }
    >
      <div>
        <Image
          src={plan.imageUrl}
          alt={plan.title}
          width={208}
          height={117}
          className="rounded-t-xl"
        />
        <div className="w-full px-4 pb-3 pt-1">
          <div className="line-clamp-2 pb-1 text-sm font-bold text-black">{plan.title}</div>
          <div className="text-brand truncate pb-2">
            {plan.categories.map((category, i) => (
              <span key={i} className="mr-2 text-xs font-bold">
                #{category}
              </span>
            ))}
          </div>
          <div className="flex items-end justify-end text-right">
            <div className="flex h-6 w-6 items-center justify-center rounded-sm bg-[#6B6B6B]">
              {plan.type === 'phone' ? (
                <PhoneIcon width={18} height={18} />
              ) : (
                <ChatIcon width={18} height={18} />
              )}
            </div>
            {maxDiscountCoupon && (
              <span className="items-end pl-1 text-sm line-through">{generatePriceText(plan)}</span>
            )}
            <span className={`pl-1 ${maxDiscountCoupon && 'font-bold text-red-500'}`}>
              {generatePriceText({
                ...plan,
                price: plan.price - (maxDiscountCoupon ? maxDiscountCoupon.price : 0),
              })}
            </span>
          </div>
        </div>
      </div>
    </button>
  );
};
